var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "help-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.56016 5.99992C6.7169 5.55436 7.02626 5.17866 7.43347 4.93934C7.84067 4.70002 8.31943 4.61254 8.78495 4.69239C9.25047 4.77224 9.67271 5.01427 9.97688 5.3756C10.2811 5.73694 10.4475 6.19427 10.4468 6.66659C10.4468 7.99992 8.44683 8.66659 8.44683 8.66659M8.50016 11.3333H8.50683M15.1668 7.99992C15.1668 11.6818 12.1821 14.6666 8.50016 14.6666C4.81826 14.6666 1.8335 11.6818 1.8335 7.99992C1.8335 4.31802 4.81826 1.33325 8.50016 1.33325C12.1821 1.33325 15.1668 4.31802 15.1668 7.99992Z",
    stroke: "#98A2B3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircle);
export default __webpack_public_path__ + "static/media/help-circle.be23b4a1080d92c05f4618ad596c75c4.svg";
export { ForwardRef as ReactComponent };